import { useDispatch, useSelector } from 'react-redux';
import {
  loadUserVacationsDetails,
  loadVacationsDetails,
  statisticSelector,
  userSelector,
  vacationsDetailsSelector,
} from '@/redux';
import { useEffect, useMemo } from 'react';
import { IAuthUser } from '@/types/user';
import { IUser } from '@/interfaces';
import { userRoles } from '@/constants';
import { useRouteMatch } from 'react-router-dom';

const useBalanceCard = (user: IAuthUser | IUser) => {
  const dispatch = useDispatch();
  const mainUser = useSelector(userSelector);
  const userRole = mainUser?.role;
  const router = useRouteMatch<{ id: string }>();

  const {
    salary,
    rate: hourlyRate,
    expectedSalary: expected,
    overtimeSalary: overtime,
  } = useSelector(statisticSelector);

  useEffect(() => {
    dispatch(
      userRole === userRoles.admin
        ? loadVacationsDetails({
            userId: router.params.id,
          })
        : loadUserVacationsDetails(),
    );
  }, [dispatch, router.params.id, user.userId, userRole]);

  const vacations = useSelector(vacationsDetailsSelector);
  const selfPaidDayOffs = vacations.filter((vacation) => vacation.paymentType === 'SelfPaid');
  const dailyRate = hourlyRate * 8;

  const progress = useMemo(
    () => (expected > 0 ? Math.round((salary / expected) * 100) : 0),
    [expected, salary],
  );

  const helpMessage = `There are $${user.rate} of rate + $${overtime} of overtime${
    selfPaidDayOffs.length
      ? ` - $${(selfPaidDayOffs.length * dailyRate).toFixed(2)} of self paid day-off${
          selfPaidDayOffs.length > 1 ? 's' : ''
        } (${selfPaidDayOffs.length})`
      : ''
  }`;

  return { salary, expected, overtime, progress, helpMessage };
};

export default useBalanceCard;
